import { fetchChatsDeleteDesktop, TChatsDeleteDesktopResponse } from '../../repositories/chats/v1/chats/delete-desktop';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';
import { deselectAllChats, toggleChatListPending } from '../chatList/actions';

/**
 * Удалить чат(ы)
 */
export const deleteChats = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const {
    chatList: { selectedChats },
  } = getState();
  const { httpApi, logger } = context;

  dispatch(toggleChatListPending(true));

  try {
    const { statusCode, response }: TChatsDeleteDesktopResponse = await fetchChatsDeleteDesktop({
      httpApi,
      parameters: {
        chatIds: selectedChats,
      },
      config: { requestConfig: { withCredentials: true } },
    });

    if (statusCode === 200) {
      dispatch(deselectAllChats());
    } else {
      logger.warning('Код ответа не 200', {
        message: 'Не удалось удалить чаты',
        domain: 'src/shared/actions/chatList/deleteChats.ts',
        statusCode,
        messsage: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });

      dispatch(showAlert({ message: 'Не удалось удалить чаты' }));
    }
  } catch (error) {
    logger.error(error, {
      message: 'Не удалось удалить чаты',
      domain: 'src/shared/actions/chatList/deleteChats.ts',
      chatIds: selectedChats,
    });

    dispatch(showAlert({ message: 'Не удалось удалить чаты' }));
  } finally {
    dispatch(toggleChatListPending(false));
  }
};
